import PropTypes from "prop-types";

const propTypes = {
  osobneUdaje: PropTypes.shape({
    // Meno alebo nazov ziadatela (ak FO, tak meno, ak PO, tak nazov)
    MENO_NAZOV_ZIADATEL: PropTypes.string,
    MENO: PropTypes.string,
    PRIEZVISKO: PropTypes.string,
    ICO: PropTypes.string,
    NAZOV: PropTypes.string,
    I_O_TYP: PropTypes.bool,
  }),
};

export default propTypes;
